// extracted by mini-css-extract-plugin
export default {"pageWrap":"G-z","fullWidth":"H-z","heading":"I-z","fullBleed":"J-z","hidden":"K-z"};